export const userRoutesPermissionChecker = () => {
    function checkFormsPermissions(locationLevelPermissions: any, userLevelPermissions: any)  {
        return locationLevelPermissions['forms_enabled'] && userLevelPermissions.includes("forms.write")
    }
    function checkQuizzesPermissions(locationLevelPermissions: any, userLevelPermissions: any)  {
        return locationLevelPermissions['quizzes_enabled'] && userLevelPermissions.includes("quizzes.write")
    }
    function checkSurveysPermissions(locationLevelPermissions: any, userLevelPermissions: any)  {
        return locationLevelPermissions['surveys_enabled'] && userLevelPermissions.includes("surveys.write")
    }
    function checkQrCodesPermissions(locationLevelPermissions: any, userLevelPermissions: any)  {
        return locationLevelPermissions['qr_codes_enabled'] && userLevelPermissions.includes("qrcodes.write")
    }
    function checkLaunchpadPermissions(locationLevelPermissions: any, userLevelPermissions: any, hideLaunchpad: boolean)  {
        return locationLevelPermissions['launchpad_enabled'] && userLevelPermissions.includes("launchpad.write") && !hideLaunchpad
    }
    return {
        checkFormsPermissions,
        checkQuizzesPermissions,
        checkSurveysPermissions,
        checkQrCodesPermissions,
        checkLaunchpadPermissions
    }
}
